import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function QuestionMark({
  color = 'status.orange',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 10 11' {...props}>
      <Path
        d='M5.00164 7.52013V5.91343C6.18478 5.91343 7.1439 4.95431 7.1439 3.77117C7.1439 2.58803
          6.18478 1.62891 5.00164 1.62891C3.8185 1.62891 2.85938 2.58803 2.85938 3.77117'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M5.00041 10.1422C4.97083 10.1422 4.94685 10.1661 4.94685 10.1957C4.94685 10.2253
          4.97083 10.2493 5.00041 10.2493C5.02999 10.2493 5.05397 10.2253 5.05397 10.1957C5.05397
          10.1661 5.02999 10.1422 5.00041 10.1422'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

QuestionMark.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default QuestionMark
